const tables = [
  {
    name: "Number",
  },
  {
    name: "Supplier",
  },
  {
    name: "Date",
  },
  {
    name: "Due",
  },
  {
    name: "Delivery",
  },
  {
    name: "Payment Status",
  },
  {
    name: "Payment",
  },
  {
    name: "Total Amount",
  },
  {
    name: "Action",
  },
];

export default tables;
